export class DissolveTransition {
    constructor(object) {
        this.name = 'dissolve';
        this.object = object;
        this.duration = 1.6;
        this.transparent = true;
    }

    createCustomMeshes(object) {}

    setTransitionUniforms(shader) {
        shader.USE_TRANSITION_DISSOLVE = true;
        // shader.needsUpdate = true;
    }

    update(progress) {
        // The actual dissolve effect is handled in the shader
        // This method is kept for consistency with other transitions
    }

    setProgress(progress) {
        // The progress is handled by the shader uniforms
        // This method is kept for consistency with other transitions
    }

    destroy() {
        // Clean up any resources if needed
    }

    reset() {
        // Reset any state if needed
        // The dissolve effect is handled in the shader, so no specific reset is needed
    }
}
